import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BusinessProblems.css';

const EnvelopeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
  </svg>
);

const DatabaseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
    <path d="M3 12a9 3 0 0 0 18 0"></path>
  </svg>
);

const FolderIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2.414-2.414L20 8H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"></path>
    <path d="M2 4h12l2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"></path>
  </svg>
);

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
);

const BusinessProblems: React.FC = () => {
  const problems = [
    {
      title: 'Depender de planillas, mails o procesos manuales',
      description: 'Mucho tiempo invertido en tareas repetitivas y propensas a errores.',
      icon: EnvelopeIcon
    },
    {
      title: 'Usar una plataforma distinta para cada tarea',
      description: 'Herramientas desconectadas que no se comunican entre sí.',
      icon: DatabaseIcon
    },
    {
      title: 'Tener la información desordenada',
      description: 'Datos dispersos, difíciles de acceder y poco confiables.',
      icon: FolderIcon
    },
    {
      title: 'Buscar pero no encontrar nada que se adapte a lo que vos y tu equipo necesitan',
      description: 'Soluciones genéricas que no solucionan tu negocio.',
      icon: SearchIcon
    }
  ];

  return (
    <section className="business-problems-section">
      <Container fluid="lg">
        <Row className="align-items-center">
          <Col lg={12} className="mx-auto">
            <div className="problems-content">
              <p className="problems-subtitle">
                UN PROBLEMA MÁS COMÚN DE LO QUE PENSÁS
              </p>
              <h2 className="problems-title">
                Como dueños de negocios muchas veces nos cansamos de...
              </h2>
              
              <div className="problems-grid">
                {problems.map((problem, index) => {
                  const IconComponent = problem.icon;
                  return (
                    <div key={index} className="problem-card">
                      <div className="problem-icon-wrapper">
                        <IconComponent />
                      </div>
                      <div className="problem-text-content">
                        <h4 className="problem-item-title">{problem.title}</h4>
                        <p className="problem-item-description">{problem.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              <p className="problems-conclusion">
                Desarrollamos software a medida para cambiar esa realidad. Creamos soluciones que se adaptan a tu negocio, integran tus procesos y te permitan escalar sin depender de herramientas genéricas.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BusinessProblems;
